import axios from "axios";
import React, { createContext } from "react";
import { baseURL } from "../Config/Config";


export const Rtr = createContext()

export const RtrProvider = ({ children }) => {
    const [rtr_data, setRtr_data] = React.useState()
    const [search, setSearch] = React.useState("");
    
    React.useEffect(() => {
        axios.get(`${baseURL}rtr_base_app/category-level-list/`).then((response) => {
            setRtr_data(response.data)
        }).catch((err) => {
            console.log(err)
        })
    }, [])
    return (
        <Rtr.Provider value={[rtr_data, setRtr_data, search, setSearch]}>
            {children}
        </Rtr.Provider>
    )
}

